import { Outlet } from 'react-router-dom'
import LocalizedNavigate from '@/components/LocalizedNavigate'
import { useAuthStore } from '@/store/authStore'

export default function RequireAuth() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  if (!isAuthenticated) {
    return <LocalizedNavigate to="/login" replace />
  }

  return <Outlet />
}
